export class ApiFetchError extends Error {
  constructor(public reason: string) {
    super(reason)
  }
}
